
import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root'
})
export class MetaTagsService {

  constructor(
    private metaService: Meta,
    private titleService: Title,
  ){}

  public setTitleTag(title?:string, prefix: boolean = false): void {
    if (!title) {
      // eslint-disable-next-line no-console
      console.info('Title is missing while recording meta info');
      return;
    }
    const limitedTitle: string = this.cleanStrings(title, 60, prefix);
    this.titleService.setTitle(limitedTitle);
    this.metaService.updateTag({property: 'og:title', content: limitedTitle});
  }

  public setDescriptionTag(description?:string): void {
    if (!description) {
      // eslint-disable-next-line no-console
      console.info('Description is missing while recording meta info');
      return;
    }
    const limitedDescription: string = this.cleanStrings(description, 200);
    this.metaService.updateTag({name: 'description', content: limitedDescription})
    this.metaService.updateTag({property: 'og:description', content: limitedDescription});
  }

  public setImageTag(url?: string): void {
    if (!url) {
      // eslint-disable-next-line no-console
      console.info('Image url is missing while recording meta info');
      return;
    }
    this.metaService.updateTag({property: 'og:image', content: url});
  }

  public setUrlTag(routerUrl?: string): void {
    if (!routerUrl) {
      // eslint-disable-next-line no-console
      console.info('Route url is missing while recording meta info');
      return;
    }
    this.metaService.updateTag({property: 'og:url', content: `${window.location.hostname}${routerUrl}`});
  }

  public getDefaultOgImage = `${window.location.protocol}//${window.location.host}/assets/viewbid/images/logo_viewbid.svg`;

  private cleanStrings(textString:string, characterLimit:number, prefix:boolean = false):string {
    return (`${(prefix ? 'Viewbid Auctions - ' : '')}${textString.replace(/<[^>]*>/g, '').substring(0, characterLimit)}`);
  }

}
